import AuthenticatedResource  from 'resources/public/AuthenticatedResource';

// -----------------------------------------------------
// Resource Definition
// -----------------------------------------------------

export default class MerchCollectionResource extends AuthenticatedResource {
  static urlRoot = '/checkin/merch_collections' as const

  readonly id: number | undefined = undefined;

  pk() {
    return this.id?.toString();
  }

}
